import { createContext } from 'react';
import { AppStoreActions, AppStoreState } from './types';

export const AppStoreInitState: AppStoreState = {
  stickySearchParams: [],
};

export const AppStoreStateContext = createContext<AppStoreState>(AppStoreInitState);
export const AppStoreActionsContext = createContext<AppStoreActions | undefined>(undefined);
